var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 550 425",
    style: {
      enableBackground: "new 0 0 550 425"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00BCEF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.42,348.12c0-2.21-59.9-72.19-58.65-115.95c1.23-43.07-0.98-91.66-34.11-118.16 c-26.68-21.35-51.92-28.37-60.74-30.3V52.55c0-17.28-14.01-31.3-31.3-31.3h-14.71c-17.28,0-31.3,14.01-31.3,31.3v31.16 c-8.82,1.93-34.05,8.96-60.74,30.3c-33.13,26.5-35.34,75.09-34.11,118.16c1.25,43.76-58.65,113.74-58.65,115.95 s-4.42,9.33,11.04,11.04c7.56,0.84,88.66,0.84,181.1,1.55c92.44-0.71,173.54-0.71,181.1-1.55 C479.83,357.45,475.42,350.33,475.42,348.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.27,409.96c29.33,0,53.97-14.08,60.96-33.13H222.31C229.3,395.88,253.94,409.96,283.27,409.96z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.055788d0030bf1e387ee8be92e953a22.svg";
export { ForwardRef as ReactComponent };